import { vec4 } from "gl-matrix";

export class Color {

    private baseColor: vec4;
    private currentColor: vec4;

    constructor(color: vec4 | string) {
        this.setBaseColor(color);
    }

    public setBaseColor(color: vec4 | string) {
        if (typeof (color) === 'string') {
            this.baseColor = this.convertHexColor(color);
        } else {
            this.baseColor = color;
        }
    }

    public getBaseColor(): vec4 {
        return this.baseColor;
    }

    public convertHexColor(hex: string): vec4 {
        let match = hex.toUpperCase().match(/([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})?/);
        let color = vec4.create();
        if (match) {
            for (var i = 0; i < color.length; i++) {
                if (match[i + 1]) {
                    color[i] = parseInt(match[i + 1], 16) / 255;
                } else {
                    color[i] = 1.0;
                }
            }
        }

        return color;
    }

    public start(): Color {
        this.currentColor = vec4.clone(this.baseColor);
        return this;
    }

    public clamp(): Color {
        for (var i = 0; i < this.currentColor.length; i++) {
            if (this.currentColor[i] > 1.0) {
                this.currentColor[i] = 1.0;
            } else if (this.currentColor[i] < 0.0) {
                this.currentColor[i] = 0.0;
            }
        }
        return this;
    }

    public vary(values: vec4): Color {
        let adds = vec4.create();
        for (var i = 0; i < values.length; i++) {
            adds[i] += Math.random() * (values[i] * 2) - values[i];
        }

        return this.add(adds);
    }

    public add(values: vec4): Color {
        for (var i = 0; i < this.currentColor.length && i < values.length; i++) {
            this.currentColor[i] += values[i];
        }
        return this.clamp();
    }

    public darken(amount: number): Color {
        return this.add(vec4.fromValues(-amount, -amount, -amount, 0));
    }

    public lighten(amount: number): Color {
        return this.add(vec4.fromValues(amount, amount, amount, 0));
    }

    public red(amount: number): Color {
        this.currentColor[0] += amount;
        return this.clamp();
    }

    public green(amount: number): Color {
        this.currentColor[1] += amount;
        return this.clamp();
    }

    public blue(amount: number): Color {
        this.currentColor[2] += amount;
        return this.clamp();
    }

    public alpha(amount: number): Color {
        this.currentColor[3] += amount;
        return this.clamp();
    }

    public morph(color: vec4 | string, strength: number): Color {
        if (typeof (color) === 'string') {
            color = this.convertHexColor(color);
        }

        for (let i = 0; i < this.currentColor.length && i < color.length; i++) {
            let dif = color[i] - this.currentColor[i];
            this.currentColor[i] += dif * strength;
        }

        return this;
    }

    public done(): vec4 {
        return this.currentColor;
    }
}
